import { render, staticRenderFns } from "./BestAddressesWidget.vue?vue&type=template&id=138ac035&scoped=true&"
import script from "./BestAddressesWidget.vue?vue&type=script&lang=js&"
export * from "./BestAddressesWidget.vue?vue&type=script&lang=js&"
import style0 from "./BestAddressesWidget.vue?vue&type=style&index=0&id=138ac035&lang=scss&scoped=true&"
import style1 from "./BestAddressesWidget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ac035",
  null
  
)

export default component.exports